import { Component, Input, ViewChild } from '@angular/core';
import { ButtonComponent } from 'components/input/button/button.component';
import { CustomInputComponent } from 'components/input/custom-input/custom-input.component';
import { CustomSelectComponent } from 'components/input/custom-select/custom-select.component';
import { InputType } from 'enums/InputType';
import { TeamModel } from 'models/generated/Identity.Api.Models.Team';
import { SelectListItemModel } from 'models/SelectList';
import { Layout } from 'modules/layout';
import { ListView } from 'modules/list-view';
import { TranslatePipe } from 'pipes/translate.pipe';
import { UserService } from 'services/user.service';
import { DashboardElementConfigurationModel, DashboardElementModel } from 'models/generated/Identity.Api.Models.DashboardElement';
import { ComponentUrl, NavigationService, UrlParam } from 'services/navigation.service';
import { DashboardService } from 'services/dashboard.service';
import { TeamDashboardElementModel } from 'models/generated/Identity.Api.Models.TeamDashboardElement';
import { DashboardType } from 'enums/DashboardType';
import { CredentialRequired } from 'services/credential.service';
import { CredentialType } from 'enums/CredentialType';
import { FormValidationService } from 'services/form-validation.service';
import { ListDashboardComponent } from './list-dashboard.component';

@Component({
	selector: 'view-dashboard-element',
	templateUrl: './view-dashboard-element.component.html',
	providers: [FormValidationService],
	imports: [Layout, CustomSelectComponent, CustomInputComponent, ListView, TranslatePipe]
})
@ComponentUrl('view-dashboard-element')
@CredentialRequired(CredentialType.DashbordAccessFull)
export class ViewDashboardElementComponent {

	@ViewChild('saveButton') saveButton!: ButtonComponent;

	inputType = InputType;
	dashboardType = DashboardType;
	public dashboardElement?: DashboardElementModel;
	public teams: { id: string, name: string, sale: boolean, selected: boolean, wasSelected: boolean }[] = [];
	public checkedTeams: SelectListItemModel[] = [];
	public dashboardTypesList = Array.from(DashboardType.getKeys().keys()).map(key => new SelectListItemModel(key, this.translate.transform('enum.dashboard-type.' + DashboardType[key])));

	@UrlParam @Input()
	set dashboardElementId(id: string | undefined) {
		this.loadDashboardElementModel(id);
		this.navigationService.openParentView(this, 'dashboard-admin', ListDashboardComponent).then(view => { view.selectedDashboardElementId = id });
	}
	get dashboardElementId() {
		return this.dashboardElement?.id;
	}

	constructor(private readonly userService: UserService,
		private readonly dashboardService: DashboardService,
		private readonly navigationService: NavigationService,
		private readonly translate: TranslatePipe,
		private readonly formValidation: FormValidationService) { }

	async loadDashboardElementModel(elementId: string | undefined) {
		this.checkedTeams = [];
		const dashboardElements = await this.dashboardService.getDashboardElements();
		this.dashboardElement = dashboardElements.find(element => element.id == elementId) ?? new DashboardElementModel();
		if (!this.dashboardElement.configuration) this.dashboardElement.configuration = new DashboardElementConfigurationModel();
		let teams = this.userService.teams;
		teams.sort((a, b) => a.name.localeCompare(b.name));
		this.teams = teams.map(team => { return { id: team.id!, name: team.name, sale: team.sale, selected: this.dashboardElement!.teamDashboardElements.some(tde => tde.teamId == team.id), wasSelected: this.dashboardElement!.teamDashboardElements.some(tde => tde.teamId == team.id) } });
		this.getCheckedTeams();
	}

	selectTeam(team: TeamModel) {
		if (!this.dashboardElement) return;
		team.selected = !team.selected;
		this.dashboardElement.teamDashboardElements = this.teams.filter(team => team.selected).map(team => { return { teamId: team.id, dashboardElementId: this.dashboardElement!.id } as TeamDashboardElementModel });
		this.getCheckedTeams();
		this.formValidation.fieldStateChanged(this, true, false);
	}

	markAsPristine() { }

	getCheckedTeams() {
		this.checkedTeams = this.teams.filter(team => team.sale && this.dashboardElement!.teamDashboardElements.filter(tde => tde.teamId == team.id).length > 0).map(team => new SelectListItemModel(team.id, team.name));
	}

	async save() {
		if (!this.dashboardElement) return;
		if (this.dashboardElement.id) {
			await this.dashboardService.updateDashboardElement(this.dashboardElement);
		}
		else {
			await this.dashboardService.createDashboardElement(this.dashboardElement);
		}
		this.formValidation.fieldStateChanged(this, true, true);
		this.saveButton.succeeded();
	}
}

